<script lang="ts">
	import { goto } from '$app/navigation';
	import { resolve } from '$app/paths';
	import { onMount } from 'svelte';

	const patientStart = resolve('/(patient)/patientStart');

	onMount(() => {
		goto(patientStart);
	});
</script>

<!-- <nav>
    <a href={resolve("/(patient)/patientStart")}>test</a>
</nav> -->
